import request from '@/utils/request'

export default {
    index: function (form) {// 统计首页
        return request({
            url: 'task/count/index',
            method: 'post',
            data: form
        });
    },
    logDetail: function (form) {//任务完成明细
        return request({
            url: 'task/count/logDetail',
            method: 'post',
            data: form
        });
    },
    logDetailWithoutLogin: function (form) {//任务完成明细--免登录
        return request({
            url: 'task/count/logDetailWithoutLogin',
            method: 'post',
            data: form
        });
    },
    info: function (form) {// 统计页基本信息
        return request({
            url: 'task/count/info',
            method: 'post',
            data: form
        });
    },
    jobList() {
        return request({
            url: "/task/count/jobList",
            method: "post"
        })
    },
    logUpDetail: function (form) {//上游数据明细
        return request({
            url: 'task/count/logUpDetail',
            method: 'post',
            data: form
        });
    }
    ,
    jdCpaDetail: function (form) {//京东数据明细
        return request({
            url: 'task/count/jdCpaDetail',
            method: 'post',
            data: form
        });
    }
    ,
    saasDetail: function (form) {//移动花卡数据明细
        return request({
            url: 'task/count/saasDetail',
            method: 'post',
            data: form
        });
    }
    ,
    suningDetail: function (form) {//苏宁易购数据明细
        return request({
            url: 'task/count/suningDetail',
            method: 'post',
            data: form
        });
    }
    ,
    jdpayOrderDetail: function (form) {//白条一分购数据明细
        return request({
            url: 'task/count/jdpayOrderDetail',
            method: 'post',
            data: form
        });
    }
    ,
    meituanDetail: function (form) {//美团数据明细
        return request({
            url: 'task/count/meiTuanDetail',
            method: 'post',
            data: form
        });
    }
    ,
    jdUnionOrderDetail: function (form) {//京东数据明细
        return request({
            url: 'task/count/jdUnionOrderDetail',
            method: 'post',
            data: form
        });
    }
    ,
    cmccOrderDetail: function (form) {//移动花卡充值版
        return request({
            url: 'task/count/cmccOrderDetail',
            method: 'post',
            data: form
        });
    }
    ,
    saasCommonDetail: function (form) {//移动花卡数据明细
        return request({
            url: 'task/count/saasCommonDetail',
            method: 'post',
            data: form
        });
    }
}